import React, { useState, useEffect, useRef } from "react";
// import Header from "../common/components/Header";
import { useNavigate } from "react-router-dom"; // Add this at the top
// import "./Alliteams.css";
import TableOrder from "./TableOrder";

import { Link } from "react-router-dom";

import { FaCommentAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";

import 'semantic-ui-css/semantic.min.css';

import axios from 'axios';
import { FaUser, FaShoppingCart, FaCreditCard, FaList, FaHeart, FaMapMarkerAlt, FaBell, FaHeadset, FaCog } from "react-icons/fa";

import { useLocation } from 'react-router-dom';
import logo from "../banner2.jpg";
import DefaultImage from "../menu1.jpg";

import allCartsImage from "../order-delivered.jpg"; // Adjust the path as needed
import SidescrollAdvertisements from "./SidescrollAdvertisements";
// import Biryanidata from './Biryanidata';
const TableCart = () => {


    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [parentId, setParentId] = useState(null);
    const isMobile = window.innerWidth <= 768;
    // const [activeCategory, setActiveCategory] = useState("Allitems");
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    // const [quantities, setQuantities] = useState({});
    const [quantities, setQuantities] = useState({}); // Track quantities of items
    const [showPopup, setShowPopup] = useState(false);
    const [popupItem, setPopupItem] = useState(null);
    const [items, setItems] = useState([]); // Store API data
    // const [quantities, setQuantities] = useState({}); // Manage quantity state
    const [categories, setCategories] = useState([]);
    const [isHovered, setIsHovered] = useState(false);
    const [dishes, setDishes] = useState([]);  // Added state for dishes
    const location = useLocation();
    const [posts, setPosts] = useState([]);
    // const [activeCategory, setActiveCategory] = useState("Allcarts");
    const navigate = useNavigate(); // Define navigate
    const [filteredItems, setFilteredItems] = useState([]);
    const [cartData, setCartData] = useState([]);
    // const [allCategories, setAllCategories] = useState(["Allcarts"]);
    // const [activeCategory, setActiveCategory] = useState("Allcarts");
    const [allCategories, setAllCategories] = useState(["Allcarts"]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    // Fetch Cart Data
    // Fetch Cart Data
    const [selectedDishId, setSelectedDishId] = useState(null); // Store the selected dishId
    const [cartItems, setCartItems] = useState([]);
    const [selectedCartId, setSelectedCartId] = useState(null);
    const [refresh, setRefresh] = useState(false);  // ✅ Define refresh state



    const [bannerData, setBannerData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");


    const vendorId = localStorage.getItem("vendorId");

    const handleCategoryClick = (category) => {
        setActiveCategory(category);

        // Ensure React updates the state immediately
        setFilteredItems(prevItems => {
            if (category === "Allcarts") return cartData;
            return cartData.filter(item => item.dishName === category);
        });

        // 🔥 Force Re-Render Immediately
        setTimeout(() => setRefresh(prev => !prev), 0);
    };

    // ✅ Trigger re-fetch when `refresh` changes
    useEffect(() => {
        let selectedItems = activeCategory === "Allcarts"
            ? cartData
            : cartData.filter(item => item.dishName === activeCategory);

        setFilteredItems([...selectedItems]);
    }, [activeCategory, cartData, refresh]); // ✅ Added `refresh` to dependencies

    // ✅ Fetch data function (runs in the background)




    // ✅ Track when `selectedCartId` and `selectedDishId` become available
    useEffect(() => {
        if (!selectedCartId || !selectedDishId) {
            console.warn("⏳ Waiting for selectedCartId and selectedDishId to be set...");
            return;
        }
        console.log("✅ selectedCartId and selectedDishId are now available");
    }, [selectedCartId, selectedDishId]); // ✅ Runs when these values change



    useEffect(() => {
        const userId = localStorage.getItem("userId");

        if (!userId) {
            console.error("🚨 User ID not found in localStorage!");
            return;
        }

        const fetchCartData = () => {
            const token = localStorage.getItem("authToken"); // ✅ get token from localStorage

            axios
                .get(
                    ` https://backend.maamaas.com/food/api/cart/${userId}/with-seating`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`, // ✅ send token in headers
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((response) => {
                    console.log("🛒 Cart Response:", response.data);

                    // ✅ Store token if a new one is returned
                    if (response.data?.token) {
                        localStorage.setItem("authToken", response.data.token);
                        console.log("🔐 Token saved to localStorage as 'authToken':", response.data.token);
                    }

                    const cartItems = Array.isArray(response.data)
                        ? response.data[0]?.cartItems || []
                        : response.data.cartItems || [];

                    setCartData(cartItems);

                    const categories = [...new Set(cartItems.map((item) => item.dishName))];
                    setAllCategories(["Allcarts", ...categories]);
                })
                .catch((error) => console.error("❌ Error fetching cart data:", error));
        };

        fetchCartData();
        const interval = setInterval(fetchCartData, 10000);

        return () => clearInterval(interval);
    }, []);




    useEffect(() => {
        if (activeCategory === "Allcarts") {
            setFilteredItems(cartData); // ✅ Show all items
        } else {
            const filtered = cartData.filter(item => item.dishId === activeCategory);
            setFilteredItems(filtered);
        }
    }, [activeCategory, cartData]); // ✅ Depend on activeCategory and cartData



    useEffect(() => {
        if (!vendorId) return;

        const token = localStorage.getItem("authToken"); // ✅ get token from localStorage
        const source = axios.CancelToken.source();

        (async () => {
            try {
                setLoading(true);

                const { data } = await axios.get(
                    ` https://backend.maamaas.com/food/banner/vendor/${vendorId}`,
                    {
                        cancelToken: source.token,
                        headers: {
                            Authorization: `Bearer ${token}`, // ✅ send token in header
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log("🎯 Banner API Response:", data);

                // 🔽 massage the fields once
                setBannerData({
                    ...data,
                    companyName: data.companyName || "No Name",
                });

                setError("");
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error("❌ Banner API Error:", err);
                    setError("Could not load banner details.");
                }
            } finally {
                setLoading(false);
            }
        })();

        return () => source.cancel();
    }, [vendorId]);




    return (
        <>
            <div className="container-fluid">
                <div className="row" style={{ marginTop: "50px", overflow: "hidden" }}>

                    {/* Sidebar */}
                    <div className="col-lg-2 col-md-3 col-sm-3 col-3">
                        <div
                            className="category-sidebar d-none d-sm-block mobile-scrolling-cart"
                            style={{
                                position: "sticky",
                                top: "0px",
                                height: "100vh",   // full screen height
                                overflowY: "auto",
                                scrollbarWidth: 'none', // sidebar independent scroll
                                width: "180px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}
                        >
                            <div className="category-containery" style={{ marginTop: "68px" }}>
                                {allCategories.map((category, index) => {
                                    const categoryImage =
                                        category === "Allcarts"
                                            ? DefaultImage          // Allcarts ke liye default
                                            : cartData.find(item => item.dishName === category)?.dishImage || DefaultImage;  // Agar image missing ho to default


                                    return (
                                        <div
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleCategoryClick(category)}
                                            style={{
                                                backgroundColor:
                                                    activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                borderRadius: "15px",
                                                transition: "0.3s ease-in-out",
                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                height: "165px",
                                            }}
                                        >
                                            <img
                                                src={categoryImage}
                                                alt={category}
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                            <div className="category-card-body d-flex justify-content-center p-0">
                                                <button
                                                    style={{
                                                        backgroundColor:
                                                            activeCategory === category ? "#ddd" : "#fff",
                                                        margin: "5px",
                                                        padding: "8px",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                        transition: "0.3s ease-in-out",
                                                    }}
                                                >
                                                    {category}
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Main Content (Independent Scroll) */}
                    <div
                        className="col-lg-7 col-md-7 col-sm-12 col-12"
                        style={{
                            maxHeight: "100vh",
                            scrollbarWidth: "none",
                            overflowY: "auto", // ✅ sirf yeh scroll karega
                        }}
                    >
                        <p
                            className="breadcrumb maamaas-home-bredcums"
                            style={{
                                marginTop: "40px",
                                fontSize: "18px",
                                marginLeft: "20px",
                                marginBottom: "10px",
                            }}
                        >
                            <Link
                                to="/"
                                style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                            >
                                Home
                            </Link>
                            <span className="separator"> &gt; </span>
                            <span className="separator"> &gt; </span>
                            <Link
                                to="/Newmenuiteam"
                                style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                            >
                                {(bannerData?.companyName || "MAAMAAS").charAt(0).toUpperCase() +
                                    (bannerData?.companyName || "MAAMAAS")
                                        .slice(1)
                                        .toLowerCase()}
                            </Link>
                            <span className="separator"> &gt; </span>
                            <span className="separator"> &gt; </span>
                            <Link
                                to=""
                                style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}
                            >
                                Cart
                            </Link>
                        </p>

                        <div
                            className="cartsizes"
                            style={{
                                marginTop: "28px",
                                padding: "20px",
                                borderRadius: "8px",
                            }}
                        >
                            <TableOrder key={activeCategory} filteredDataProp={filteredItems} />
                        </div>





                        <div
                            className="col-lg-2"
                            style={{ display: isMobile ? "none" : "block" }}
                        >
                            <SidescrollAdvertisements />
                        </div>

                    </div>


                </div>



            </div>
        </>
    );
};

export default TableCart;




